import {
    GET_PERMISSION_LISTING,
    GET_PERMISSION_LISTING_SUCCESS,
    GET_PERMISSION_LISTING_FAIL,
    GET_PERMISSION_DETAILS,
    GET_PERMISSION_DETAILS_SUCCESS,
    GET_PERMISSION_DETAILS_FAIL,
    ADD_PERMISSION,
    ADD_PERMISSION_SUCCESS,
    ADD_PERMISSION_FAIL,
    UPDATE_PERMISSION,
    UPDATE_PERMISSION_SUCCESS,
    UPDATE_PERMISSION_FAIL,
    DELETE_PERMISSION,
    DELETE_PERMISSION_SUCCESS,
    DELETE_PERMISSION_FAIL,
    EXPORT_PERMISSION,
    EXPORT_PERMISSION_SUCCESS,
    EXPORT_PERMISSION_FAIL,
    RESET_PERMISSION_STATE,
} from "./actionTypes";

export const getPermissionListing = () => ({
    type: GET_PERMISSION_LISTING,
});

export const getPermissionListingSuccess = permission => ({
    type: GET_PERMISSION_LISTING_SUCCESS,
    payload: permission,
});

export const getPermissionListingFail = error => ({
    type: GET_PERMISSION_LISTING_FAIL,
    payload: error,
});

export const getPermissionDetails = permissionId => ({
    type: GET_PERMISSION_DETAILS,
    payload: permissionId,
});

export const getPermissionDetailsSuccess = permission => ({
    type: GET_PERMISSION_DETAILS_SUCCESS,
    payload: permission,
});

export const getPermissionDetailsFail = error => ({
    type: GET_PERMISSION_DETAILS_FAIL,
    payload: error,
});

export const createPermission = permission => ({
    type: ADD_PERMISSION,
    payload: permission,
});

export const createPermissionSuccess = permission => ({
    type: ADD_PERMISSION_SUCCESS,
    payload: permission,
});

export const createPermissionFail = error => ({
    type: ADD_PERMISSION_FAIL,
    payload: error,
});

export const updatePermission = permission => ({
    type: UPDATE_PERMISSION,
    payload: permission,
});

export const updatePermissionSuccess = permission => ({
    type: UPDATE_PERMISSION_SUCCESS,
    payload: permission,
});

export const updatePermissionFail = error => ({
    type: UPDATE_PERMISSION_FAIL,
    payload: error,
});

export const deletePermission = permissionId => ({
    type: DELETE_PERMISSION,
    payload: permissionId,
});

export const deletePermissionSuccess = permissionId => ({
    type: DELETE_PERMISSION_SUCCESS,
    payload: permissionId,
});

export const deletePermissionFail = error => ({
    type: DELETE_PERMISSION_FAIL,
    payload: error,
});

export const exportPermission = () => ({
    type: EXPORT_PERMISSION,
});

export const exportPermissionSuccess = data => ({
    type: EXPORT_PERMISSION_SUCCESS,
    payload: data,
});

export const exportPermissionFail = error => ({
    type: EXPORT_PERMISSION_FAIL,
    payload: error,
});

//reset
export const resetPermissionState = () => {
    return {
        type: RESET_PERMISSION_STATE,
    }
}

